import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { OtpPage } from './index';
import VerifyOtp from './VerifyOtp';

export interface OtpRoutingProps extends RouteComponentProps { }

export const OtpRouting = (props: OtpRoutingProps) => {
  return (
    <div className="bg-black/50 inline-flex flex-col justify-center items-center w-full h-screen">
      <Switch>
        <Route path={`${props.match.path}/:itemUuid`} component={OtpPage} exact />
        <Route path={`${props.match.path}/enter-code/:itemUuid`} component={VerifyOtp} exact />
      </Switch>
    </div>
  );
};
